/* template */
<template minapp="mpx" xlang="wxml"><div class="recommend-drawer"><div class="info"><div class="left"><div class="tag">{{ recommendCardInfo.tag }}</div>{{ recommendCardInfo.info }}</div><div>{{ recommendCardInfo.seat }}</div></div><more-less-guide :guide="(recommendCardInfo.guide)"/><div class="tips"><div class="tips-order" v-if="(makeOrder)">温馨提示：<hl-text :text="(recommendCardInfo.orderTips)" :hlColor="(recommendCardInfo.highlight)" class="tips-order-text"/></div><hl-text :text="(recommendCardInfo.tips)" :hlColor="(recommendCardInfo.highlight)" class="tips-text" v-else/></div><mpx-view @tap="goWarning" class="warning" v-if="(showWarning)">利用”买短乘长“恶意逃票属违法行为，情节严重的将被追究刑事责任</mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m14bd2c2b"}'>
  @import '~@/mixins/stylus/color.styl'

  .recommend-drawer
    padding 21px 16px 10px
    font-family PingFang SC
    font-size 14px
    font-weight 500
    color #222222
    background #FFFFFF
  .info
    display flex
    align-items center
    justify-content space-between
    width 100%
    margin-bottom 14px
  .left
    display flex
    align-items center
  .tag
    background #338FFF
    margin-right 8px
    border-radius 4px
    color #FFFFFF
    font-size 12px
    width 58px
    height 18px
    line-height 18px
    text-align center
  .tips
    font-size 12px
    background #F2F6F9
    border-radius 6px
    margin-top 20px
    height 32px
    line-height 32px
    vertical-align middle
    //文字前空格
    padding-left 12px
    &-text
      color #222222
      font-weight 400
      line-height 32px
      vertical-align middle
    &-order
      font-weight 500
      display flex
      align-items center
      &-text
        margin-top -1px
        color #222222
        font-weight 400
  .warning
    font-size 10px
    color #999999
    margin-top 8px
    margin-bottom -2px
    position relative
    &::after
      position absolute
      content ''
      width 4px
      height 4px
      border-top 1px solid
      border-right 1px solid
      position absolute
      top 5px
      right 2px
      transform rotate(45deg)
  .pay-container
    height 100px
    padding 11px 14px 0 16px
    box-shadow inset 0px 1px 0px 0px #EEEEEE
    border-radius 10px 10px 0px 0px
    display flex
    justify-content space-between
    align-items baseline
  .price
    color #FF6400
    font-size 32px
    font-weight 500
    display flex
    align-items baseline
    &-symbol
      font-size 16px
      font-weight normal
  .btn
    width 140px
    height 50px
    background #FF6400
    color #FFFFFF
    font-size 16px
    font-weight 500
    display flex
    align-items center
    justify-content center
    border-radius 10px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m14bd2c2b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./recommend-ticket-card.mpx.js?isComponent&outputPath=components%2Frecommend-ticket-card14bd2c2b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./recommend-ticket-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Frecommend-ticket-card14bd2c2b%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m14bd2c2b"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/recommend-ticket-card14bd2c2b/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'more-less-guide':getComponent(require("./more-less-guide.mpx?isComponent&outputPath=components%2Fmore-less-guide0bb010cb%2Findex")),'hl-text':getComponent(require("../hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'controllable-drawer-bottom':getComponent(require("../controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
